// import { createSelector } from "reselect";

export const getHeaderTitle = (state) => state.header.title;
